import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/public/form/submit/adobe-pdf-library-newsletter', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('订阅失败，请稍后重试。');
      }
    } catch (error) {
      setStatus('error');
      setMessage('订阅失败，请稍后重试。');
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-cyan-600">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className="mb-8">
          <i className="ri-mail-line text-5xl text-white mb-6 block"></i>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            订阅我们的资讯
          </h2>
          <p className="text-xl text-teal-50 max-w-2xl mx-auto">
            获取最新的PDF技术资讯、产品更新和行业洞察
          </p>
        </div>
        <form 
          id="adobe-pdf-library-newsletter"
          data-readdy-form
          onSubmit={handleSubmit}
          className="max-w-md mx-auto"
        >
          <div className="flex flex-col sm:flex-row gap-4">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="flex-1 px-6 py-4 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-white text-sm"
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="bg-white text-teal-600 hover:bg-teal-50 px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {status === 'loading' ? '提交中...' : '立即订阅'}
            </button>
          </div>
          {status === 'success' && (
            <div className="mt-4 p-4 bg-white/20 rounded-lg text-white">
              {message}
            </div>
          )}
          {status === 'error' && (
            <div className="mt-4 p-4 bg-red-500/20 rounded-lg text-white">
              {message}
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
